import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "grouped-metrics-table",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description:
      "Sortable table comparing entities across labeled metric groups, with an optional per-row drill-down.",
    domain: "reports",
    visual: "Table",
    purposes: ["reporting"],
    reportEdition: true,
    audiences: ["analyst", "client"],
  },
  layout: { skeleton: "table" },
  defaultLayoutClassName: "col-span-12",
};
